import { useTranslation } from 'react-i18next'

import { dataLayerPublish } from '@dhl/datalayer'
import { usePutProfileMobilePhoneVerify, type VerifyMobilePhoneRequest } from '@dhl/receiver-profile-api'
import { useSnackbar } from '@dhl-ui/components'

import { useGetProfileErrorTranslation } from '../../hooks/useGetProfileErrorTranslation.js'

export const useVerifyProfileMobileNumber = () => {
  const { mutateAsync: verifyProfileMobileNumber } = usePutProfileMobilePhoneVerify()
  const getProfileErrorTranslation = useGetProfileErrorTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  return async (values: VerifyMobilePhoneRequest): Promise<void> => {
    try {
      await verifyProfileMobileNumber({
        data: values,
      })
      enqueueSnackbar(t('portal.profile.mobileNumberPage.mobileNumberVerificationDone'), {
        severity: 'success',
      })
    } catch (error) {
      dataLayerPublish('ERROR', { error, page: 'verify-mobile-number' })

      const errorMessage = getProfileErrorTranslation(error)
      enqueueSnackbar(errorMessage, { severity: 'error' })

      throw error
    }
  }
}
